/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as workOrderActions from 'actions/workOrderActions';
import AssignedServiceOrders from 'workOrderComponents/AssignedServiceOrders';
import Footer from 'containers/Footer';
import * as mouseFlowUtils from '../../utils/mouseFlowUtils';
import { TAG_MY_ROUTE_PAGE } from '../../constants/mouseFlow';
import log from 'utils/logger';

const logger = log('MyRoutePage');

export class MyRoutePage extends React.Component {

    constructor (props){
        super(props);
        mouseFlowUtils.setTag(TAG_MY_ROUTE_PAGE);
    }

    componentDidMount() {
        const {techData, user, workOrderActions} = this.props;
        const userId = user.get('userId');
        const workOrderLoading = techData.getIn(['techs', userId, 'workOrderLoading']);
        const workOrderLoadingFinished = techData.getIn(['techs', userId, 'workOrderLoadingFinished']);
        const techId = techData.getIn(['techs', userId, 'info', 'techId']) || null;
        const auxiliaryTechId = techData.getIn(['techs', userId, 'info', 'auxiliaryTechId']) || null;
        const isFieldAdmin = user.get('isFieldAdmin') || false;
        const routeLoadedTime = techData.getIn(['techs', userId, 'routeLoadedTime']) || null;

        const shouldLoadOrders = !workOrderLoading && !workOrderLoadingFinished;

        logger.warn({
            category: 'route-load-diagnostic',
            userId,
            techId,
            auxiliaryTechId,
            isFieldAdmin,
            workOrderLoading: !!workOrderLoading,
            workOrderLoadingFinished: !!workOrderLoadingFinished,
            routeLoadedTime,
            shouldLoadOrders,
        });

        if (userId && shouldLoadOrders) {
            workOrderActions.workOrderGetTechRouteStarted({userId: userId, isSelf: true});
        }
    }

    render() {

        const {techData, user, workOrder, history, workOrderActions} = this.props;
        let errorDisplay = null;
        const userId = user.get('userId');
        const workOrderLoading = techData.getIn(['techs', userId, 'workOrderLoading']);
        const workOrderLoadingError = techData.getIn(['techs', userId, 'workOrderLoadingError']);

        if (workOrderLoadingError) {
            errorDisplay = (
                <div className="card-panel red darken-4 white-text">
                    {workOrderLoadingError}
                </div>
            );
        }

        const routeRefreshed = techData.getIn(['techs', userId, 'routeLoadedTime']);

        const assignedServiceOrders = techData.getIn([
            'techs',
            this
                .props
                .user
                .get('userId'),
            'assignedServiceOrders'
        ]);

        return (
            <div>
                {errorDisplay}
                <AssignedServiceOrders
                    workOrderLoading={workOrderLoading}
                    userId={userId}
                    isSelf={true}
                    history={history}
                    assignedServiceOrders={assignedServiceOrders}
                    workOrder={workOrder}
                    routeRefreshed={routeRefreshed}
                    workOrderActions={workOrderActions}
                    refreshAction={workOrderActions.workOrderGetTechRouteStarted}/>
                <Footer/>
            </div>
        );
    }
}

MyRoutePage.propTypes = {
    workOrder: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    techData: PropTypes.object.isRequired,
    workOrderActions: PropTypes.object.isRequired,
    history: PropTypes.object
};

function mapStateToProps(state) {
    return {
        workOrder: state.get('workOrder'),
        techData: state.get('techData'),
        user: state.get('user')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        workOrderActions: bindActionCreators(workOrderActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MyRoutePage);


// WEBPACK FOOTER //
// ./src/containers/pages/MyRoutePage.js